export enum EvaSourceType {
  Policy = 'policy',
  Applicant = 'applicant',
  Discussion = 'discussion',
  Email = 'email',
}

export enum EvaSourceName {
  Policy = 'Policy',
  Applicant = 'Applicant',
  Discussion = 'Discussion',
  Email = 'Email',
}

/** User-facing noun per source type, used in the source-popover unavailable messages. */
export enum EvaSourceLabel {
  Policy = 'policy',
  Discussion = 'discussion',
  Applicant = 'applicant',
}
